import { IAppState } from "..";

export const getUser = (state: IAppState) => state.authReducer.me;

export const getUserCountryCode = (state: IAppState) => getUser(state)?.country.code;
